<template>
  <div :style="noCoincideHistorico() ? 'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;' : ''">
    <f7-popover class="history-popover" :closeByBackdropClick="false" :backdrop="true" closeOnEscape ref="popoverHistory" style="width: auto; max-width: 90%;">
      <div style="min-width: 250px;">
        <f7-navbar :title="$t('Historico de cambios')">
          <f7-nav-right>
            <f7-link popover-close icon-f7="multiply"></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <div class="scrollable-content">
            <table>
              <thead>
                <tr style="background-color: #22355b;color: #FFF;">
                  <th>Id</th>
                  <th>Valor</th>
                  <th>Fecha</th>
                  <th>Usuario</th>
                </tr>
              </thead>
              <tbody  v-if="form.username != 'NOID'">
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-auditoria">{{itm.id}}</td>
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">{{getStrValueHistory(itm.valor)}}</td>
                  <td class="datos-auditoria">{{itm.date}}</td>
                  <td class="datos-auditoria">{{itm.username || ' - '}}</td>
                </tr>
              </tbody>
              <tbody  v-else>
                <tr v-for="(itm, idx) in history" :key="'history-' + idx" :class="(idx%2?'fila-impar':'fila-par')">
                  <td class="datos-valor" :title="itm && itm.msgHistory?itm.msgHistory:''">
                    <f7-list-input
                      :value="getValueHistory(itm.valor)"
                      autocomplete="no"
                      @input="setValueHistory($event.target.value, $event.target, false, false, itm)"
                      @change="type == 'date' || type == 'datetime-local' ? null : setValueHistory($event.target.value, $event.target, true, false, itm)"
                      @calendar:change="type == 'date' || type == 'datetime-local' ? null : setValueHistory($event, 'calendar', false, false, itm)"
                      v-on="$listeners"
                      :class="{readonly:form.username == 'NOID' ? form.readonly : (overrideReadonly ? readonly : (readonly || form.readonly)), inputDate:type == 'date' || type == 'datetime-local', inputDate:allMayus?'allMayus':'','no-list-decorator':!listDecorator}"
                      @input:clear="setValueHistory(null, null, false, false, itm)"
                      :type="type == 'integer' ? 'number' : type"
                      :resizable="resizable"
                    ></f7-list-input>
                  </td>
                  <td class="datos-auditoria">{{itm.date}}</td>
                  <td class="datos-auditoria">{{itm.username || ' - '}}</td>
                  <td class="datos-opciones">
                    <f7-link @click="updateHistory(itm)" icon-f7="floppy_disk"></f7-link>
                    <f7-link @click="deleteFieldFromHistory(itm)" icon-f7="trash" color="red"></f7-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </f7-block>
      </div>
    </f7-popover>
    <f7-list-input
      :value="getValue()"
      type="text"
      autocomplete="off"
      @input="updateIfEmpty"
      @blur="onBlur"
      v-bind="{...$attrs,...$props}"
      @keyup.enter.native="onPressEnter"
      v-on="$listeners"
      :error-message-force="!!form.errors[name]"
      :error-message="form.errors[name]"
      :readonly="overrideReadonly ? readonly : readonly || form.readonly"
      :class="{readonly:overrideReadonly ? readonly : readonly || form.readonly, 'cordova-workaround': target == 'cordova', 'navigation-link': getShowNavigationLink()}"
      v-tooltip="viewTooltip ? (label ? label + ':<br>' : '') + ((getValue() || getValue() === 0) ? getValue() : '') : ''"
      :clear-button="!(overrideReadonly ? readonly : readonly || form.readonly) && clearButton && (getValue() === 0 || !!getValue())"
      @input:clear="setValue({})"
      @focus="focused = true"
      class="r-autocomplete"
    >
      <slot name="inner-end" slot="inner-end">
        <f7-link
          v-if="getShowDecorationLink()"
          :icon-f7="decorationConfig.icon"
          :color="decorationConfig.color"
          v-tooltip="decorationConfig.tooltip"
          @click="decorationConfig.action()"
          class="input-suffix-btn r-input-little r-input-top decoration-link"
        ></f7-link>

        <f7-link
          v-if="hasHistory && Utils.posterior2Dic2024(form.dateRef)"
          class="input-suffix-btn r-input-little r-input-top history-link"
          :class="{'color-historico-ultimo-online': hayCambiosOnline()}"
          :icon-f7="'archivebox'"
          v-tooltip="'Historico de valores'"
          @click="showHistory"
          style="transform: translateY(-2px);"
        ></f7-link>

        <f7-link
          v-if="getShowNavigationLink()"
          :href="getDetailUrl()"
          class="input-suffix-btn"
          icon-f7="arrow_up_right_square"
          color="green"
          external
          v-tooltip="'Navegar a seleccionado'"
          style="transform: translateY(2px);"
        ></f7-link>
      </slot>
      <slot name="inner-start" slot="root-end"></slot>
    </f7-list-input>
    <span v-if="htmlError" v-tooltip="tooltipError" v-html="htmlError()" @click.prevent="mostrarError()" style="z-index: 100;"></span>
      
  </div>
</template>
<style scoped>
/* Ajustar posición del botón clear 3px a la izquierda */
.r-autocomplete :deep(.input-clear-button) {
  transform: translateX(-3px);
}
</style>
<script>

import DatabaseModel from '../js/db/DatabaseModel';
import ConfigCombo from '../js/db/ConfigCombo';
import DateUtils from "./../js/DateUtils";
import Utils from "./../js/Utils";
import EntityUtils from "./../js/EntityUtils";
import JSONPath from 'jsonpath';

export default {
  data() {
    return {
      _jqxhr: null,
      isLoading: false,
      items: [],
      initialItems: [],
      selected: null,
      autocomplete: null,
      DatabaseModel,
      dbAdapterData: null,
      target: process.env.TARGET,
      preloaded: false,
      timeoutGetData: null,
      focused: false,
      history: [],
      EntityUtils,
      Utils,
      JSONPath
    };
  },
  computed: {
    hasHistory: function () {
      return this.form?.history && this.form?.history[this.name];
    },
  },
  methods: {
    isTranslationKey: function(value) {
      // Determina si un valor parece una clave de traducción
      // Las claves de traducción suelen tener puntos y no espacios
      return typeof value === 'string' && 
             value.includes('.') && 
             !value.includes(' ') && 
             value.length > 3;
    },
    mostrarError: function() {
      const self = this;
      var app = self.$f7;
      let expediente = self.form.formData;
      let htmlError = expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name))
                .flatMap(e => e.errores)
                .map(e => '<div class="regla regla-'+e.tipoRegla+'" ><span style="color: black;">'+e.nombre + '.- </span>' + e.error+'</div>').join(' ');
      let msg = '<div>' + htmlError + '</div>';
      app.dialog.alert(msg,'Errores del campo');
    },
    htmlError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.formateoError(expediente, self.altername || self.name);
      }
      return msgError;
    },
    tooltipError: function() {
      const self = this;
      let expediente = self.form.formData;
      let msgError;
      if(expediente.listErrorsForLabel && expediente.listErrorsForLabel.filter(e => e.valor == (self.altername || self.name)).length)
      {
        msgError = EntityUtils.tooltipError(expediente, (self.altername ||self.name));
      }
      return msgError;
    },
    onPressEnter: function() {
      const self = this;
      if (self.async && self.items && self.items.length) {
        self.setValue(self.items[0]);
        self.autocomplete.close();
      }
    },
    setFilter: function(filter, loadIfOne = true) {
      const self = this;
      if (filter) {
        self.setValue({}, false);
        self.autocomplete.preloaderShow();
        var {params, shownFields} = self.getRemoteData(filter);
        params.filter = params.filter || {};
        self.dbAdapterData
          .getCombo(params, [...shownFields])
          .then(function(res) {
            self.preloaded = true;
            self.items = res.list;
            self.$emit("loaded", res.list);
            if (loadIfOne && self.items && self.items.length == 1) {
              self.setValue(self.items[0]);
            }
            self.autocomplete.preloaderHide();
          })
          .catch(function(e) {
            self.autocomplete.preloaderHide();
          });
      } else {
        self.setValue({});
        self.preloaded = false;
      }
    },
    getDetailUrl: function() {
      const self = this;
      var currentUrl = new URL(window.location.href);
      
      if (self.detailUrl) {
        return currentUrl.pathname + self.detailUrl.replace(':id', self.getIdValue());
      }
      return currentUrl.pathname + ('#!/' + self.dbAdapterData.modelFront + '/view/' + self.getIdValue() + '/');
    },
    getShowNavigationLink: function() {
      const self = this;
      const idValue = self.getIdValue();
      if (!idValue || !self.showNavigationLink) {
        return false;
      }
      if (self.detailUrl) {
        return true;
      }

      return self.dbAdapterData && self.dbAdapterData.modelFront;
    },
    updateIfEmpty: function(e) {
      if (!e.target.value && e.inputType == "deleteContentBackward") {
        this.setValue({});
        this.form.$emit("change", this.name, {});
      }
    },
    onBlur: function(e) {
      const self = this;
      self.focused = false;
      if (self.getValue() !== 0 && !!!self.getValue() && e.target.value) {
        e.target.value = "";
        this.setValue({});
        this.form.$emit("change", this.name, {});
      }
    },
    reload(items) {
      var self = this;
      if (self.configCombo) {
        // La carga del configcombo se hace en created() — ya está en marcha o
        // resuelta. Si hay autoSelectValue, esperamos a que llegue y lo aplicamos.
        if (self.autoSelectValue && self.configComboPromise) {
          self.configComboPromise.then(function () { self.setValue(self.autoSelectValue); });
        }
        return;
      }
      if (!self.async) {
        if (self.dbAdapterData) {
          const {params, shownFields} = self.getRemoteData();
          self.dbAdapterData
            .getCombo(params, [...shownFields])
            .then(function(res) {
              self.items = res.list;
              self.initialItems = res.list;
              if (self.autoSelectValue) {
                self.setValue(self.autoSelectValue);
              } else if (self.getValue()) {
                self.source(self)(self.getValue(), res => {
                  if (res && res.length == 1 && res[0] != self.getValue()) {
                    self.setValue(res[0]);
                  }
                })
              }
              if (self.focused) {
                self.autocomplete.renderDropdown();
                self.autocomplete.open();
                self.autocomplete.openDropdown();
              }
              self.$emit("loaded", res.list);
            })
            .catch(function(e) {
              console.log(e);
            });
        } else {
          items = items || self.dbItems;
          self.items = items;
          self.initialItems = items;
          self.$emit("loaded", items);
        }
      }
    },
    getRemoteData: function(filterInput) {
      const self = this;
      var filters = filterInput || self.filter;
      var params = Object.assign({}, filters);
      var shownFields = new Set(self.shownFields);
      shownFields.add('id');
      if(self.labelProp) shownFields.add(self.labelProp);
      if(self.prefixProp) shownFields.add(self.prefixProp);
      if(self.idProp) shownFields.add(self.idProp);
      if(self.searchProp) shownFields.add(self.searchProp);
      return {params: params, shownFields: shownFields};
    },
    getValue: function() {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        if (typeof context == "undefined" || context == null) context = {};
        context = context[namespaces[i]];
      }
      if (typeof context == "undefined" || context == null) context = {};
      var selected = self.items.filter(function(i){
        return i[self.idProp] == context;
      })
      if (selected && selected.length > 0) {
        self.selected = selected[0];
      } else {
        self.selected = context;
      }
      if (selected && selected.length > 0) {
        const labelValue = selected[0][self.labelProp];
        const translatedLabel = self.isTranslationKey(labelValue) ? self.$t(labelValue) : labelValue;
        return self.prefixProp && selected[0][self.prefixProp] ? (selected[0][self.prefixProp] + ' - ' + translatedLabel) : translatedLabel;
      }

      if (typeof context == "string") {
        return context[self.labelProp] || context;
      } else {
        const labelValue = context[self.labelProp];
        const translatedLabel = self.isTranslationKey(labelValue) ? self.$t(labelValue) : labelValue;
        return self.prefixProp && context[self.prefixProp] ? (context[self.prefixProp] + ' - ' + translatedLabel) : translatedLabel;
      }

    },
    showHistory: function(event) {
      const self = this;
      // Clonamos shallow cada item para que el formateo posterior no mute el histórico original.
      self.history = (self.form.history[self.name] || []).map(itm => ({...itm}));
      // vamos a formatear los campos de fecha
      for (var i = 0; i < self.history.length; i++) {
        if(self.history[i].valor === undefined) {
          self.history[i].valor = '';
        }
        if(self.history[i].valorAnterior === undefined) {
          self.history[i].valorAnterior = '';
        }
        self.history[i].date = DateUtils.dateFormat(self.history[i].date, 'DD/MM/YYYY HH:mm');
        self.history[i].username = self.history[i].username || '-';
      }
      if(event.target) self.$refs.popoverHistory.open(event.target);
    },
    hayCambiosOnline: function () {
      const self = this;
      if (typeof self.name === 'string' && self.name.indexOf('sesionesManuales.') === 0) return false;
      let colorear = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            colorear = true;
            break;
          }
        }
      }
      if (!colorear) return false;
      let history = self.form.history ? self.form.history[self.name] : null;
      history = history ? [...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      if (!history.length) return false;
      const sesionesManuales = self.form.formData ? self.form.formData.sesionesManuales : null;
      return !Utils.fechaEnSesionesManuales(history[0].date, sesionesManuales);
    },
    noCoincideHistorico: function () {
      const self = this;
      // miramos si el usuario tiene rol ADMINISTRACION, ADMIN o DTYCAL 
      let nocoincide = false;
      let roles = self.form.user ? self.form.user.roles : null;
      if (roles && roles.length) {
        for (var i = 0; i < roles.length; i++) {
          if (roles[i] == 'ADMINISTRACION' || roles[i] == 'ADMIN' || roles[i] == 'DTYCAL') {
            nocoincide = true;
            break;
          }
        }
      }
      let history = self.form.history ? self.form.history[self.name] : null;
      // ahora ordenamos el historico por fecha y nos quedamos con el elemento mas reciente
      history = history ? [...history] : [];
      history = history.sort((a, b) => new Date(b.date) - new Date(a.date));
      // miraremos si el valor del historico más reciente, coincide con el del componente y si no coincide, devolveremos true
      return nocoincide && history && history.length && self.getStrValueHistory(history[0].valor) != self.getStrValueHistory(self.getValue());
    },
    getStrValueHistory(valor) {
      const self = this;
      let val = valor;
      if (self.items && val) {
        var selected = self.items.filter(function(i){
          return i[self.idProp] == val;
        })
        if (selected && selected.length > 0) {
          const labelValue = selected[0][self.labelProp];
          const translatedLabel = self.isTranslationKey(labelValue) ? self.$t(labelValue) : labelValue;
          val = self.prefixProp && selected[0][self.prefixProp] ? (selected[0][self.prefixProp] + ' - ' + translatedLabel) : translatedLabel;
        }
      }
      return val;
    },
    getValueHistory(valor) {
      const self = this;
      var context = valor;
      return context;
    },
    setValueHistory: function(val, a, desdeChange = false, extraDataEmit = false, itm) {
      const self = this;
      itm.valor = val;
    },
    updateHistory: function(itm) {
      const self = this;
      // buscamos la entrada del historico en form.historyBulk por el id
      let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
      if(historyBulk) {
        historyBulk.date = new Date(self.getDateHistory(itm.date));
        historyBulk.username = itm.username;
      }
      let namespaces = self.name.split(".");
      let context = historyBulk?.nuevo;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.$set(context, namespaces[i], itm.valor);
        } else if (context[namespaces[i]] == null) {
          self.$set(context, namespaces[i], {});
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
      context = itm.valor;
      // console.log("historyBulk", context);
      // ahora guardaremos el historico con su nuevo valor
      self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
        .then(function() {
          self.$f7.dialog.alert("El historico se ha actualizado correctamente.");
        })
        .catch(function(error) {
          if(error.status && error.status == 404) {
            console.log("error 404 URL: " + error.url);
          } else {
            app.dialog.alert(error.message);
          }
        });
      self.$refs.popoverHistory.close();
    },
    deleteFieldFromHistory: function(itm) {
      const self = this;
      self.$f7.dialog.confirm(
              "La línea de historico se eliminará y no podrá ser recuperada. ¿Está seguro?",
              "Advertencia",
              () => {
                // el delete va a ser un update en el que hemos eliminado el campo del valor actual
                let historyBulk = self.form.historyBulk.find(h => h.id == itm.id);
                let namespaces = self.name.split(".");
                let context = historyBulk?.nuevo;
                let contextParent = historyBulk?.nuevo;
                for (var i = 0; i < namespaces.length; i++) {
                  if (i == namespaces.length - 1) {
                    self.$set(context, namespaces[i], itm.valor);
                  } else if (context[namespaces[i]] == null) {
                    self.$set(context, namespaces[i], {});
                  } else if (typeof context[namespaces[i]] == "undefined") {
                    let n = namespaces[i + 1];
                    if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
                      //Número entero positivo
                      self.$set(context, namespaces[i], []);
                    } else {
                      self.$set(context, namespaces[i], {});
                    }
                  }
                  contextParent = context;
                  context = context[namespaces[i]];
                }
                // eliminamos el objeto context del contextParent
                if (contextParent) {
                  delete contextParent[namespaces[namespaces.length - 1]];
                  itm = undefined;
                }
                // ahora guardaremos el historico con su nuevo valor
                self.form.dbAdapter.saveHistory({ itemId: historyBulk.id, data: historyBulk })
                  .catch(function(error) {
                    if(error.status && error.status == 404) {
                      console.log("error 404 URL: " + error.url);
                    } else {
                      app.dialog.alert(error.message);
                    }
                  });
                self.$refs.popoverHistory.close();
              },
              () => {
                // Cancelar
              }
            );
      
    },
    getIdValue: function() {
      var self = this;
      const idField = self.idFieldDetail || self.idProp || 'id';
      const namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        if (typeof context == "undefined" || context == null) context = {};
        context = context[namespaces[i]];
      }
      if (typeof context == "undefined" || context == null) return "";
      var selected = self.items.filter(function(i){
        return i[self.idProp] == context;
      })
      if (selected && selected.length > 0) {
        return selected[0][idField];
      }

      if (typeof context == "string") {
        return context[idField] || context;
      } else {
        return context[idField];
      }

    },
    setValue: function(val, sendEvent = true) {
      var self = this;
      var namespaces = self.name.split(".");
      var context = self.form.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (i == namespaces.length - 1) {
          self.selected = val;
          var value = val;
          if (self.idProp) {
            value = val[self.idProp];
          }
          value = self.beforeChange(value);
          self.$set(context, namespaces[i], value);
          if (self.nameId) {
            var namespace = namespaces[i];
            if (self.nameId) {
              namespace = self.nameId;
            }
            self.$set(context, namespace, value);
          } 
          if (sendEvent) {
            self.$emit("change", val, self);
            self.form.$emit("change", namespace, val);
          }
        } else if (typeof context[namespaces[i]] == "undefined") {
          let n = namespaces[i + 1];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            self.$set(context, namespaces[i], []);
          } else {
            self.$set(context, namespaces[i], {});
          }
        }
        context = context[namespaces[i]];
      }
    },
    getShowDecorationLink: function() {
      const self = this;
      if (self.decorationConfig) {
        if (self.decorationConfig.showDecoration) {
          return self.decorationConfig.showDecoration()
        } else {
          return true;
        }
      } else {
        return false;
      }
    }

  },
  props: {
    dbAdapter: {
      type: Object
    },
    name: {
      required: true,
      type: String
    },
    altername: {
      required: false,
      type: String,
      default: ''
    },
    nameId: {
      type: String
    },
    form: {
      required: false,
      type: Object,
      default: function() {
        return {};
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    overrideReadonly: {
      type: Boolean,
      default: false
    },
    labelProp: {
      type: String,
      default: "name"
    },
    prefixProp: {
      type: String
    },
    idProp: {
      type: String,
      default: ""
    },
    minLength: {
      type: Number,
      default: 0
    },
    searchProp: {
      type: String,
      default: function() {
        return this.labelProp;
      }
    },
    beforeChange: {
      type: Function,
      default: function(item) {
        return item;
      }
    },
    filter: {
      type: Object,
      default: function() {
        return {};
      }
    },
    autoSelectValue: {
      type: Object
    },
    viewTooltip: {
      type: Boolean,
      default: true
    },
    shownFields: {
      type: Array,
      default: function (){
        return [];
      }
    },
    defaultFilterSourceAsync: {
      type: Function,
      default: function () {
        return function() {
          return {};
        };
      }
    },
    showItem: {
      type: Function,
      default: function () {
        return function(item) {
          return true;
        };
      }
    },
    source: {
      type: Function,
      default: function(self) {
        return function(query, render) {
          var results = [];
          if (self.preloaded) {
            for (var i = 0; i < self.items.length; i++) {
              const originalValue = self.items[i][self.searchProp];
              const translatedValue = self.isTranslationKey(originalValue) ? self.$t(originalValue) : originalValue;
              var txtValue = translatedValue;
              if (self.prefixProp && self.items[i][self.prefixProp]) {
                const prefixValue = self.items[i][self.prefixProp];
                const translatedPrefix = self.isTranslationKey(prefixValue) ? self.$t(prefixValue) : prefixValue;
                txtValue = translatedPrefix + ' - ' + translatedValue;
              }
              if (
                (txtValue === 0 || txtValue) &&
                txtValue.toString() &&
                txtValue.toString()
                  .toLowerCase()
                  .indexOf(query.toLowerCase()) >= 0 &&
                self.showItem(self.items[i])
              ) {
                self.items[i]['txtValue'] = txtValue.toString();
                results.push(self.items[i]);
              }
            }
            render(results);
          } else if (self.async && self.dbAdapterData && query.length >= self.minLength) {
            self.autocomplete.preloaderShow();
            var {params, shownFields} = self.getRemoteData();
            params.filter = Object.assign({} , params.filter, {withoutAggregations: true}, self.defaultFilterSourceAsync());
            params.filter[self.searchProp] = query;
            if (self.timeoutGetData) {
              clearTimeout(self.timeoutGetData);
            }
            self.timeoutGetData = setTimeout(() => {
                self.dbAdapterData
                  .getCombo(params, [...shownFields])
                  .then(function(res) {
                    self.items = res.list;
                    self.$emit("loaded", res.list);
                    //self.autocomplete.preloaderHide();
                    render(res.list);
                  })
                  .catch(function(e) {
                    self.autocomplete.preloaderHide();
                    render(results);
                  });
            }, 1000);
            
          } else {
            self.items = self.initialItems;
            if (query.length >= self.minLength) {
              for (var i = 0; i < self.items.length; i++) {
                const originalValue = self.items[i][self.searchProp];
                const translatedValue = self.isTranslationKey(originalValue) ? self.$t(originalValue) : originalValue;
                var txtValue = translatedValue;
                if (self.prefixProp && self.items[i][self.prefixProp]) {
                  const prefixValue = self.items[i][self.prefixProp];
                  const translatedPrefix = self.isTranslationKey(prefixValue) ? self.$t(prefixValue) : prefixValue;
                  txtValue = translatedPrefix + ' - ' + translatedValue;
                }
                if (
                  (txtValue === 0 || txtValue) &&
                  txtValue.toString() &&
                  txtValue.toString().toLowerCase().indexOf(query.toLowerCase()) >= 0 &&
                  self.showItem(self.items[i])
                ) {
                  self.items[i]['txtValue'] = txtValue.toString();
                  results.push(self.items[i]);
                }
              }
            }
            render(results);
          }
        };
      }
    },
    onchange: {
      type: Function,
      default: function(self) {
        return function(value) {
          self.setValue(value[0]);
          // self.$emit("change", value[0]);
          // self.form.$emit("change", self.name, value[0]);
        };
      }
    },
    autocompleteProps: {
      type: Object,
      default: function() {
        var $ = this.$$;
        var $el = $(this.$el);
        var self = this;
        return {};
      }
    },
    label: {
      type: String,
      default: ""
    },
    dbItems: {
      type: Array,
      default: function() {
        return [];
      }
    },
    openIn: {
      type: String,
      default: "dropdown"
    },
    infoText: {
      type: String
    },
    async: {
      type: Boolean,
      default: false
    },
    model: {
      type: String
    },
    configCombo: {
      // Código de un configcombo (tabla maestra) del que se cargarán los items
      // (configcombo.valores). Si se informa, se ignora dbAdapter/model.
      type: String,
      default: ""
    },
    clearButton: {
      type: Boolean,
      default: true
    },
    validation: {
      type: Object
    },
    showNavigationLink: {
      type: Boolean,
      default: true
    },
    detailUrl: {
      type: String
    },
    idFieldDetail: {
      type: String
    },
    decorationConfig: {
      type: Object,
      default: null
    }
  },
  created: function() {
    var self = this;
    // Si el componente carga de un configcombo, lanzamos la consulta lo antes
    // posible (en created, no en mounted) para minimizar la race con la apertura
    // del dropdown F7 — el usuario suele tardar más en hacer click que la consulta
    // en resolverse.
    if (self.configCombo) {
      self.configComboPromise = ConfigCombo.getList({ filter: { codigo: self.configCombo } })
        .then(function (res) {
          var c = res && res.list && res.list[0];
          var valores = (c && c.valores) || [];
          var mapped = valores.map(function (v) {
            var labelHumano = v.label || v.nombre || v.nombre_valor || v.valor;
            return Object.assign({}, v, v.metadatos || {}, { label: labelHumano, nombre: labelHumano });
          });
          self.items = mapped;
          self.initialItems = mapped;
          self.preloaded = true;
          self.$emit("loaded", mapped);
        })
        .catch(function (e) { console.log(e); });
    }
  },
  mounted() {
    var $ = this.$$;
    var $el = $(this.$el);
    var self = this;
    if (self.validation) {
      self.form.validateFields[self.name] = self.validation;
    }
    if (self.configCombo) {
      // Sin dbAdapter: los items vienen del configcombo (cargado en reload()).
      self.dbAdapterData = null;
    } else if (self.model) {
      var obj = Object.create(DatabaseModel);
      obj.model = self.model;
      self.dbAdapterData = obj;
    } else {
      self.dbAdapterData = self.dbAdapter;
    }
    self.autocomplete = self.$f7.autocomplete.create({
      ...{
        openIn: self.openIn,
        openerEl: $el,
        closeOnSelect: true,
        inputEl: $el.find("input"),
        preloader: true,
        highlightMatches: true,
        dropdownPlaceholderText: self.infoText ? self.infoText : (self.minLength > 0 ? 'Introduzca al menos ' + self.minLength + ' caracteres' : null),
        requestSourceOnOpen: true,
        dropdownContainerEl: $el,
        valueProperty: self.idProp || self.searchProp,
        textProperty: self.async ? self.searchProp : 'txtValue',
        source: self.source(self),
        on: {
          change: self.onchange(self)
        }
      },
      ...self.autocompleteProps
    });
    self.reload();
  },
  destroyed() {
    var self = this;
    if (self.validation) {
      delete self.form.validateFields[self.name];
    }
  }
};
</script>
<style>
.readonly input,
.readonly select {
  pointer-events: none;
}
.autocomplete-dropdown-inner {
  max-height: 170px;
}
.autocomplete-dropdown {
  min-width: 400px;
}
</style>